import { FC } from 'react'
import { useFormContext } from 'react-hook-form'
import get from 'lodash/get'

import InlineSpinner from '../display/InlineSpinner'
import { InputGroup, Label, ErrorLabel } from '../form'

import AuthPlacesInput, { SelectedPlace } from './AuthPlacesInput'

type Props = {
  ready?: boolean
  noMargin?: boolean
}

const AuthLocationField: FC<Props> = ({ ready = true, noMargin }) => {
  const {
    register,
    setValue,
    formState: { errors, isSubmitted },
  } = useFormContext()
  const error = get(errors, 'user[location]')
  const showError = Boolean(error) && isSubmitted

  return (
    <InputGroup lessMargin noMargin={noMargin}>
      <Label htmlFor="user[location]" error={showError}>
        Location
      </Label>

      {ready === false ? (
        <InlineSpinner />
      ) : (
        <AuthPlacesInput
          name="user[location]"
          rules={{
            required: 'This field is required',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            validate: ((_value: any, formValues: any) => {
              const lat = get(formValues, 'user[latitude]')
              const lng = get(formValues, 'user[longitude]')
              return lat != null && lng != null
                ? true
                : 'Please select a valid location from the dropdown'
            }) as any,
          }}
          onSelect={({ latitude, longitude }: SelectedPlace) => {
            // The visible input's value is owned by the DOM (Google sets it
            // directly via Places autocomplete). We only sync the hidden
            // lat/lng so the native form submit serialises them.
            setValue('user[latitude]' as any, latitude, {
              shouldValidate: true,
              shouldDirty: true,
            })
            setValue('user[longitude]' as any, longitude, {
              shouldValidate: true,
              shouldDirty: true,
            })
          }}
          error={showError}
        />
      )}

      {showError && (
        <ErrorLabel htmlFor="user[location]">
          {error?.message as string}
        </ErrorLabel>
      )}

      <input type="hidden" {...register('user[latitude]' as any)} />
      <input type="hidden" {...register('user[longitude]' as any)} />
    </InputGroup>
  )
}

export default AuthLocationField
